(() => {
  'use strict';
  if (window.pepiMenuNavigation) return;
  window.pepiMenuNavigation = true;
  const desktop = window.matchMedia('(min-width: 1025px)');
  const navSelector = '#t4s-nav-ul';
  const drawerSelector = '#t4s-menu-drawer';
  const rootSelector = '[data-pepi-vegetaux]';
  const mounted = new WeakSet();
  const observedDrawers = new WeakSet();
  let keyboard = false;

  function collapseDetails(root) {
    root.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
  }

  function selectPanel(root, value) {
    root.querySelectorAll('[data-pepi-section]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.pepiSection === value));
    });
    root.querySelectorAll('[data-pepi-panel]').forEach(panel => {
      const selected = panel.dataset.pepiPanel === value;
      if (!selected) collapseDetails(panel);
      panel.hidden = !selected;
    });
  }

  function resetPlants(container) {
    container.querySelectorAll(rootSelector).forEach(root => {
      collapseDetails(root);
      selectPanel(root, 'outdoor');
    });
  }

  function topItem(target) {
    return target instanceof Element ? target.closest(`${navSelector} > li`) : null;
  }

  function setOpen(nav, selected) {
    Array.from(nav.children).forEach(item => {
      const panel = item.querySelector(':scope > .t4s-sub-menu');
      if (!panel) return;
      const open = desktop.matches && item === selected;
      if (!open && item.dataset.pepiMenuOpen === 'true') resetPlants(item);
      item.dataset.pepiMenuOpen = String(open);
      const link = item.querySelector(':scope > a');
      if (link) {
        link.setAttribute('aria-expanded', String(open));
        if (panel.id) link.setAttribute('aria-controls', panel.id);
      }
    });
  }

  function closeDesktop() {
    document.querySelectorAll(navSelector).forEach(nav => setOpen(nav, null));
  }

  function closeMobile(item) {
    collapseDetails(item);
    resetPlants(item);
    [item, ...item.querySelectorAll('.is--opend')].forEach(entry => {
      entry.classList.remove('is--opend');
      const panel = entry.querySelector(':scope > ul');
      if (panel) panel.style.display = 'none';
      entry.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
    });
  }

  function mount() {
    document.querySelectorAll(navSelector).forEach(nav => {
      if (mounted.has(nav)) return;
      mounted.add(nav);
      setOpen(nav, null);
      nav.dataset.pepiNavigation = 'true';
    });
    document.querySelectorAll(rootSelector).forEach(root => {
      if (mounted.has(root)) return;
      mounted.add(root);
      const switcher = root.querySelector('.pepi-vegetaux-switch');
      if (switcher) {
        switcher.setAttribute('role', 'group');
        const hint = document.createElement('p');
        hint.className = 'pepi-vegetaux-hint';
        hint.textContent = switcher.getAttribute('aria-label');
        switcher.before(hint);
      }
      selectPanel(root, 'outdoor');
    });
    document.querySelectorAll(drawerSelector).forEach(drawer => {
      if (observedDrawers.has(drawer)) return;
      observedDrawers.add(drawer);
      new MutationObserver(() => {
        if (drawer.getAttribute('aria-hidden') === 'true') {
          drawer.querySelectorAll('.is--opend').forEach(closeMobile);
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    const item = topItem(event.target);
    if (item && !item.contains(event.relatedTarget)) {
      keyboard = false;
      setOpen(item.parentElement, item);
    }
  });
  document.addEventListener('pointerout', event => {
    if (!desktop.matches || keyboard || event.pointerType === 'touch') return;
    const item = topItem(event.target);
    if (item && !item.contains(event.relatedTarget)) setOpen(item.parentElement, null);
  });
  document.addEventListener('pointerdown', event => {
    keyboard = false;
    if (!topItem(event.target)) closeDesktop();
  }, true);
  document.addEventListener('focusin', event => {
    const item = topItem(event.target);
    if (item && desktop.matches) setOpen(item.parentElement, item);
    else closeDesktop();
  });
  document.addEventListener('focusout', event => {
    const item = topItem(event.target);
    if (keyboard && item && !item.contains(event.relatedTarget)) setOpen(item.parentElement, null);
  });
  document.addEventListener('keydown', event => {
    keyboard = true;
    const item = topItem(event.target);
    if (!item || !desktop.matches) return;
    const link = item.querySelector(':scope > a');
    const panel = item.querySelector(':scope > .t4s-sub-menu');
    if (event.key === 'Escape') {
      event.preventDefault();
      link?.focus({ preventScroll: true });
      setOpen(item.parentElement, null);
    } else if (panel && event.target === link && ['ArrowDown', ' '].includes(event.key)) {
      event.preventDefault();
      setOpen(item.parentElement, item);
    }
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-pepi-section]');
    const root = button?.closest(rootSelector);
    if (root) {
      event.preventDefault();
      selectPanel(root, button.dataset.pepiSection);
      return;
    }
    const drawer = event.target.closest(drawerSelector);
    const link = event.target.closest('a');
    const item = link?.parentElement;
    if (!drawer || !item?.classList.contains('t4s-menu-item-has-children')) return;
    if (!item.classList.contains('t4s-only_icon_false') && !event.target.closest('.t4s-mb-nav__icon')) return;
    Array.from(item.parentElement.children).forEach(sibling => {
      if (sibling !== item && sibling.classList.contains('is--opend')) closeMobile(sibling);
    });
    if (item.classList.contains('is--opend')) {
      collapseDetails(item);
      resetPlants(item);
    }
    queueMicrotask(() => {
      link.setAttribute('aria-expanded', String(item.classList.contains('is--opend')));
    });
  }, true);
  document.addEventListener('toggle', event => {
    const detail = event.target;
    if (!(detail instanceof HTMLDetailsElement) || !detail.open || !detail.closest(`${drawerSelector} .mobile-preview`)) return;
    Array.from(detail.parentElement.children).forEach(sibling => {
      if (sibling !== detail && sibling instanceof HTMLDetailsElement) sibling.open = false;
    });
  }, true);
  desktop.addEventListener('change', () => {
    closeDesktop();
    document.querySelectorAll(`${drawerSelector} .is--opend`).forEach(closeMobile);
  });
  mount();
  new MutationObserver(mount).observe(document.body, { childList: true, subtree: true });
})();
